import DBTIRESULT from "../../../../src/events/2022/04/dbti/result/main";
import * as React from 'react';
export default {
  DBTIRESULT,
  React
};